import { EMPTY_LIST } from '../../../../constants/common'
import { ICON_HEIGHT_16, IconNG } from '../../../Icon'
import { getRentalPortalProfileTabCount } from '../../RentalPortal.utils'
import { RentalPortalApplicantProfileCompliance } from '../RentalPortalApplicantProfileCompliance'
import { RentalPortalApplicantProfileDocuments } from '../RentalPortalApplicantProfileDocuments'
import { RentalPortalApplicantProfileEmails } from '../RentalPortalApplicantProfileEmails'
import { RentalPortalApplicantProfileTabOverview } from '../RentalPortalApplicantProfileTabOverview'
import { RentalPortalApplicantProfileUpdates } from '../RentalPortalApplicantProfileUpdates'
import { RentalPortalApplicantProfileViewings } from '../RentalPortalApplicantProfileViewings'

import { APPLICANT_PROFILE_TAB } from './RentalPortalApplicantProfileTabs.constants'

import ComplianceIcon from '../../../../icons/lock.svg'

function getIsApplicantProfileTabVisible({ applicantData, id, isFailClosed }) {
  const decision = (applicantData?.tabs ?? EMPTY_LIST).find(
    tab => tab.key === id
  )

  return decision ? Boolean(decision.visible) : !isFailClosed
}

function getApplicantProfileTabCountersFromTabs(tabs) {
  return (tabs ?? EMPTY_LIST).reduce((acc, tab) => {
    acc[tab.key] = { total: getRentalPortalProfileTabCount(tab.count) }

    return acc
  }, {})
}

export function getApplicantProfileTabsWithVisibility(tabs) {
  return tabs.map(({ isFailClosed, ...tab }) => ({
    ...tab,
    getIsVisible: applicantData =>
      getIsApplicantProfileTabVisible({
        applicantData,
        id: tab.id,
        isFailClosed,
      }),
  }))
}

export function getApplicantProfileTabCounters(applicantData) {
  return {
    [APPLICANT_PROFILE_TAB.emails]: {
      total: getRentalPortalProfileTabCount(applicantData?.counts?.emails),
    },
    ...getApplicantProfileTabCountersFromTabs(applicantData?.tabs),
  }
}

export function getIsApplicantProfileComplianceTab(tab) {
  return tab.id === APPLICANT_PROFILE_TAB.compliance
}

export function getApplicantProfileTabsWithComplianceIcon({
  iconClassName,
  preparedTabs,
}) {
  return preparedTabs.map(tab =>
    getIsApplicantProfileComplianceTab(tab)
      ? {
          ...tab,
          text: (
            <>
              <IconNG
                Icon={ComplianceIcon}
                className={iconClassName}
                size={ICON_HEIGHT_16}
              />
              {tab.text}
            </>
          ),
        }
      : tab
  )
}

export function getApplicantProfileTabContent({ activeTabId, applicantId }) {
  switch (activeTabId) {
    case APPLICANT_PROFILE_TAB.compliance:
      return <RentalPortalApplicantProfileCompliance />
    case APPLICANT_PROFILE_TAB.documents:
      return <RentalPortalApplicantProfileDocuments />
    case APPLICANT_PROFILE_TAB.emails:
      return <RentalPortalApplicantProfileEmails key={applicantId} />
    case APPLICANT_PROFILE_TAB.overview:
      return <RentalPortalApplicantProfileTabOverview />
    case APPLICANT_PROFILE_TAB.updates:
      return <RentalPortalApplicantProfileUpdates />
    case APPLICANT_PROFILE_TAB.viewings:
      return <RentalPortalApplicantProfileViewings />
    default:
      return null
  }
}
